import { useEffect } from "react";

const DOMAIN = "https://baazcapital.com";

function setMeta(selector, attributes) {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement("meta");
    document.head.appendChild(node);
  }
  Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, value));
}

function removeMeta(selector) {
  document.head.querySelector(selector)?.remove();
}

export const Seo = ({ title, description, path = "/", image = "/assets/baaz-og.jpg", imageAlt = "Baaz Capital investment and wealth perspectives", article, articleMeta, noIndex = false, noCanonical = false }) => {
  useEffect(() => {
    const canonical = path === "/" ? `${DOMAIN}/` : `${DOMAIN}${path}`;
    const socialImage = image.startsWith("http") ? image : `${DOMAIN}${image}`;
    document.title = title;
    setMeta('meta[name="description"]', { name: "description", content: description });
    setMeta('meta[name="robots"]', { name: "robots", content: noIndex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1" });
    setMeta('meta[property="og:title"]', { property: "og:title", content: title });
    setMeta('meta[property="og:description"]', { property: "og:description", content: description });
    setMeta('meta[property="og:url"]', { property: "og:url", content: canonical });
    setMeta('meta[property="og:type"]', { property: "og:type", content: article ? "article" : "website" });
    setMeta('meta[property="og:image"]', { property: "og:image", content: socialImage });
    setMeta('meta[property="og:image:alt"]', { property: "og:image:alt", content: imageAlt });
    if (image === "/assets/baaz-og.jpg") {
      setMeta('meta[property="og:image:width"]', { property: "og:image:width", content: "1200" });
      setMeta('meta[property="og:image:height"]', { property: "og:image:height", content: "630" });
    } else {
      removeMeta('meta[property="og:image:width"]');
      removeMeta('meta[property="og:image:height"]');
    }
    setMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    setMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    setMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    setMeta('meta[name="twitter:image"]', { name: "twitter:image", content: socialImage });
    setMeta('meta[name="twitter:image:alt"]', { name: "twitter:image:alt", content: imageAlt });
    if (articleMeta) {
      setMeta('meta[property="article:published_time"]', { property: "article:published_time", content: articleMeta.publishedTime });
      setMeta('meta[property="article:modified_time"]', { property: "article:modified_time", content: articleMeta.modifiedTime });
      setMeta('meta[property="article:section"]', { property: "article:section", content: articleMeta.section });
    } else {
      removeMeta('meta[property="article:published_time"]');
      removeMeta('meta[property="article:modified_time"]');
      removeMeta('meta[property="article:section"]');
    }
    let link = document.head.querySelector('link[rel="canonical"]');
    if (noCanonical) link?.remove();
    else {
      if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
      link.href = canonical;
    }
    let script = document.getElementById("route-structured-data");
    if (script) script.remove();
    if (article) {
      script = document.createElement("script");
      script.id = "route-structured-data";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(article);
      document.head.appendChild(script);
    }
  }, [title, description, path, image, imageAlt, article, articleMeta, noIndex, noCanonical]);
  return null;
};